import React from "react";

/**
 * Ilustración del panel de acceso: una hoja de presupuesto.
 *
 * Dos detalles la hacen de esta casa y no una imagen genérica de contabilidad:
 *
 *  - El encabezado de la hoja son las franjas diagonales de una claqueta. LCI
 *    hace presupuestos de cine, no contabilidad a secas.
 *  - El renglón del total lleva doble raya debajo, que es como se marca un
 *    total en contabilidad.
 *
 * Va en SVG en línea para que herede la paleta y se vea nítida en cualquier
 * pantalla, sin pedir un archivo extra.
 */

const CREMA = "#FBF7F0";
const CREMA_HONDA = "#EFE7DA";
const VERDE_HONDO = "#2F5D45";
const VERDE = "#4C8461";
const VERDE_PALIDO = "#CFE0D5";
const AMBAR = "#F0C36B";
const CORAL = "#EE9A72";
const ROSA = "#E4788C";
const VINO = "#C2445C";

/** Renglón del presupuesto: la cuenta a la izquierda, el monto a la derecha. */
function Renglon({ y, anchoCuenta, anchoMonto, tono }) {
  return (
    <g>
      <rect x="110" y={y} width={anchoCuenta} height="9" rx="4.5" fill={VERDE_PALIDO} />
      <rect
        x={278 - anchoMonto}
        y={y}
        width={anchoMonto}
        height="9"
        rx="4.5"
        fill={tono}
      />
    </g>
  );
}

export default function PresupuestoArt({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 400 430"
      role="img"
      aria-label="Una hoja de presupuesto con sus cuentas, sus montos y el total cuadrado"
      focusable="false"
    >
      {/* piso */}
      <ellipse cx="200" cy="392" rx="108" ry="13" fill="#8FB4A0" opacity="0.55" />

      {/* hoja de atrás: da profundidad al montón */}
      <rect
        x="122"
        y="74"
        width="190"
        height="292"
        rx="12"
        fill={CREMA_HONDA}
        transform="rotate(5 217 220)"
      />

      {/* hoja principal */}
      <rect x="88" y="52" width="212" height="308" rx="14" fill={CREMA} />

      {/* encabezado con las franjas de una claqueta */}
      <path d="M88 66a14 14 0 0 1 14-14h184a14 14 0 0 1 14 14v30H88Z" fill={VERDE_HONDO} />
      <g fill={CREMA} opacity="0.9">
        <path d="M112 52h16l-12 44h-16Z" />
        <path d="M152 52h16l-12 44h-16Z" />
        <path d="M192 52h16l-12 44h-16Z" />
        <path d="M232 52h16l-12 44h-16Z" />
        <path d="M272 52h14v44h-2l-12-44Z" />
      </g>

      {/* cuentas: la barra izquierda es el nombre, la derecha el monto */}
      <Renglon y={130} anchoCuenta={104} anchoMonto={52} tono={CORAL} />
      <Renglon y={162} anchoCuenta={128} anchoMonto={38} tono={AMBAR} />
      <Renglon y={194} anchoCuenta={88} anchoMonto={60} tono={ROSA} />
      <Renglon y={226} anchoCuenta={118} anchoMonto={44} tono={CORAL} />
      <Renglon y={258} anchoCuenta={96} anchoMonto={32} tono={AMBAR} />

      {/* renglón del total, con la doble raya de contabilidad */}
      <rect x="110" y="298" width="72" height="11" rx="5.5" fill={VERDE} />
      <rect x="210" y="296" width="68" height="14" rx="7" fill={VINO} />
      <rect x="210" y="318" width="68" height="2.5" rx="1.25" fill={VERDE_HONDO} />
      <rect x="210" y="325" width="68" height="2.5" rx="1.25" fill={VERDE_HONDO} />

      {/* monedas: el presupuesto es dinero, no sólo renglones. Van fuera de la
          hoja, apoyadas en el piso, para que no se encimen con el total. */}
      <g>
        <ellipse cx="322" cy="378" rx="34" ry="12" fill={AMBAR} />
        <ellipse cx="322" cy="366" rx="34" ry="12" fill={CORAL} />
        <ellipse cx="322" cy="354" rx="34" ry="12" fill={AMBAR} />
        <ellipse cx="322" cy="354" rx="19" ry="6.5" fill={CREMA} opacity="0.5" />
      </g>

      {/* pequeñas marcas de aire, como en el resto del panel */}
      <circle cx="86" cy="120" r="11" fill={CREMA} />
      <circle cx="66" cy="150" r="6" fill={AMBAR} />
      <circle cx="330" cy="128" r="8" fill={CREMA} opacity="0.9" />
      <circle cx="344" cy="152" r="5" fill={AMBAR} opacity="0.9" />
      <circle cx="78" cy="316" r="7" fill={CREMA} opacity="0.85" />
    </svg>
  );
}
